export const environment = {
  production: true,
  /*apiBaseUrl: 'http://localhost:8080',*/
  apiBaseUrl: 'https://trading-backend-921007534851.europe-west3.run.app',
  openAiApiKey: '',
  openAiBaseUrl: 'https://api.openai.com/v1',
  openAiModel: 'gpt-5.1'
};